// Targets should implement the following method:
// onClickOutside(e) {
//   ...
// }


export default {

  mounted() {
    addEventListener('click', this._windowClickListener, true);
  },

  beforeDestroy() {
    removeEventListener('click', this._windowClickListener);
  },

  methods: {
    _windowClickListener(e) {
      if (!this.$el.contains(e.target)) {
        this.onClickOutside && this.onClickOutside(e);
      }
    }
  }
};
